import { css } from '@emotion/core';

export default theme => ({
  header: css`
    ${
      theme?.classes?.structure?.padding?.space?.top[3] ?? 'padding-top:1.5rem;'
    }
    ${
      theme?.classes?.structure?.padding?.space?.left[3] ??
      'padding-left:1.5rem;'
    }
    ${
      theme?.classes?.structure?.padding?.space?.right[3] ??
      'padding-right:1.5rem;'
    }

    &.vds-dialog-card--head {
      display: flex;
      border-top: 4px solid transparent;
    }

    .vds-dialog-card--head-icon {
      top: 0.4rem;
    }

    & h2 {
      display: inline-block;
      color: inherit;
      font-weight: 600;
      font-size: 1.25rem;
      text-transform: none;
    }
  `,
  footer: css`
    height: 56px;
    padding: 0;
    align-self: flex-end;
    background: ${theme?.variables?.colors?.element?.highlight ??
    'rgba(224,234,250,1)'};

    & .cybs-form-footer {
      border-left: none;
      border-right: none;
    }
  `,
  body: css`
    div&.vds-dialog-card--body {
      overflow: visible;
      ${
        theme?.classes?.structure?.padding?.space?.bottom[4] ??
        'padding-bottom:2rem;'
      }
      ${
        theme?.classes?.structure?.padding?.space?.left[3] ??
        'padding-left:1.5rem;'
      }
      ${
        theme?.classes?.structure?.padding?.space?.right[3] ??
        'padding-right:1.5rem;'
      }

      & p {
        color: inherit;
      }
    }
  `,
  dialogClass: css`
    @media (max-width: 320px) {
      padding: 0 10px 0 10px;
    }

    &.vds-dialog[role="dialog"]{
      overflow-y: auto;
    }

    &.vds-state--show[role="dialog"]{
      display: block !important;
    }
    
    & > div:first-child {
      max-width: 25rem;
      border-radius: 0.25rem;
    }

    & .vds-dialog-card {
      max-width: 100%;
      max-height: none !important;
      margin: 80px auto;
      color: ${theme?.cybs?.base?.wcag21?.charcoal ?? '#000000'};
      border: 1px solid ${theme?.cybs?.base?.wcag21?.stoneGrey ?? '#62798D'};
    }

    & .vds-dialog-card--footer {
      border-radius: 0 0 0.25rem 0.25rem;
      padding: 0;
    }

    &.vds-dialog {
      &.vds-state--warning .vds-dialog-card--head {
        border-top-color: ${theme?.cybs?.base?.wcag21?.amberOrange ?? '#9B6603'};
        .vds-icon use {
          fill: ${theme?.cybs?.base?.wcag21?.amberOrange ?? '#9B6603'};
        }
      }

      &.vds-state--success .vds-dialog-card--head {
        border-top-color: ${theme?.cybs?.base?.wcag21?.collardGreen ?? '#2D6C4B'};
        .vds-icon use {
          fill: ${theme?.cybs?.base?.wcag21?.collardGreen ?? '#2D6C4B'};
        }
      }

      &.vds-state--error .vds-dialog-card--head {
        border-top-color: ${theme?.cybs?.base?.wcag21?.romaRed ?? '#B3202A'};
        .vds-icon use {
          fill: ${theme?.cybs?.base?.wcag21?.romaRed ?? '#B3202A'};
        }
      }

      &.vds-state--info .vds-dialog-card--head {
        border-top-color: ${theme?.cybs?.base?.wcag21?.midnightBlue ?? '#021E4C'};
        .vds-icon use {
          fill: ${theme?.cybs?.base?.wcag21?.midnightBlue ?? '#021E4C'};
        }
      }
    }
  `
});
